<form (ngSubmit)="generateLabel()" [formGroup]="form">
	<h1 mat-dialog-title>{{'selectPrintLabelView.title' | translate}}</h1>
	<mat-dialog-content>
		<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
			<mat-form-field>
				<mat-label>{{'selectPrintLabelView.printLabelLabel' | translate}}</mat-label>
				<mat-select [formControlName]="'labelProcedureId'">
					<mat-option *ngFor="let l of availableShippingLabels" [value]="l.procedureId">
						{{l.description}}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-checkbox *ngIf="data?.showIncludePiecesCheckbox && selectedLabelIsDefault" [color]="'primary'"
						  [formControlName]="'includePieces'">Print individual piece labels
			</mat-checkbox>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
		<button [color]="'accent'" mat-dialog-close mat-raised-button type="button">
			{{'selectPrintLabelView.closeButton' | translate}}
		</button>
		<button [color]="'primary'" [disabled]="form?.invalid" mat-raised-button type="submit">
			{{'selectPrintLabelView.generateLabelButton' | translate}}
		</button>
	</mat-dialog-actions>
</form>
